const themes = {
  brand: {
    primary: { light: '#5555A5', dark: '#5555A5' },
    secondary: { light: '#5FD3C7', dark: '#5FD3C7' },
    background: { light: '#ffffff', dark: '#1f1f1f' },
    foreground: { light: '#1f1f1f', dark: '#e0e0e0' },
  },
  components: {
    muted: { light: '#ffffff', dark: '#303030' },
    'muted-accent': { light: '#9E9E9E', dark: '#9E9E9E' },
    'muted-foreground': { light: '#E5E5E5', dark: '#6B6B6B' },
  },
  inputs: {
    border: { light: '#6B6B6B', dark: '#6B6B6B' },
    input: { light: '#e0e0e0', dark: '#303030' },
  },
  other: {
    error: { light: '#e63946', dark: '#e63946' },
    success: { light: '#43aa8b', dark: '#43aa8b' },
    warning: { light: '#FFC107', dark: '#FFC107' },
    info: { light: '#77C8D0', dark: '#77C8D0' },
    'scroll-background': { light: '#e63946', dark: '#e63946' },
    // Cores específicas para o projeto do drive para manter o padrão de cores atuais
    white: { light: '#ffffff', dark: '#ffffff' },
    black: { light: '#000000', dark: '#000000' },
    initButton: { light: '#544F69', dark: '#544F69' },
    subHeaderBackground: { light: '#F5F5F5', dark: '#303030' },
    accessPermissionDialogButtons: { light: '#42A5F5', dark: '#42A5F5' },
    shadow: { light: '#000000', dark: '#000000' },
    buttonTextColor: { light: '#1E88E5', dark: '#1E88E5' },
  },
};

const flatten = (mode) => Object.values(themes).reduce(
  (merged, group) => ({
    ...merged,
    ...Object.entries(group).reduce(
      (grouped, [token, value]) => ({
        ...grouped,
        [token]: value[mode],
      }),
      {},
    ),
  }),
  {},
);

export const lightTheme = flatten('light');
export const darkTheme = flatten('dark');
export const groupedTokens = Object.keys(themes).reduce(
  (acc, key) => ({
    ...acc,
    [key]: Object.keys(themes[key]),
  }),
  {},
);

export default themes;
